import { format, subMonths, endOfMonth, startOfMonth, parseISO } from 'date-fns';

/**
 * Get default date range for filters:
 * - End date: Last day of previous month
 * - Start date: 12 months before end date (first day of that month)
 * 
 * Example: If today is 2/14/2026
 * - End date: 1/31/2026 (last day of January)
 * - Start date: 2/1/2025 (12 months lookback)
 */
export const getDefaultDateRange = () => {
  const today = new Date();
  
  // Get last day of previous month
  const previousMonth = subMonths(today, 1);
  const endDate = endOfMonth(previousMonth);
  
  // Get first day of month 12 months before end date
  const startDate = startOfMonth(subMonths(endDate, 11));
  
  // Format as strings first, then create dates to avoid timezone issues
  const startDateStr = format(startDate, 'yyyy-MM-dd');
  const endDateStr = format(endDate, 'yyyy-MM-dd');
  
  return {
    startDate,
    endDate,
    startDateStr,
    endDateStr
  };
};

/**
 * Parse a date string (yyyy-MM-dd) into a Date object without timezone shift
 * This ensures the date displayed matches the date string
 */
export const parseDateString = (dateStr) => {
  if (!dateStr) return undefined;
  // Split the date string and create date with local timezone
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Format date for display
 */
export const formatDisplayDate = (date) => {
  if (!date) return '';
  return format(new Date(date), 'MMM d, yyyy');
};

/**
 * Format date for API
 */
export const formatApiDate = (date) => {
  if (!date) return null;
  return format(new Date(date), 'yyyy-MM-dd');
};
